// Central frontend env reader. Always import from here - never read import.meta.env elsewhere.

const env = {
  APP_ENV: import.meta.env.VITE_APP_ENV || 'tbd',
  APP_NAME: import.meta.env.VITE_APP_NAME || 'ITEC Mobiles & Computers',
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api',
  SITE_URL: import.meta.env.VITE_SITE_URL || 'http://localhost:5173',
  ENABLE_ANALYTICS: String(import.meta.env.VITE_ENABLE_ANALYTICS) === 'true',
  GA_MEASUREMENT_ID: import.meta.env.VITE_GA_MEASUREMENT_ID || '',
  ASSET_BASE_URL: import.meta.env.VITE_ASSET_BASE_URL || '',
};

export const isProduction = () => env.APP_ENV === 'prd';
export const isTbd = () => env.APP_ENV === 'tbd';

export default env;
